<template>
	<div class="bg-white" style="margin-top: 5rem">
		<div id="printable" style="font-family: sans-serif">
			<div
				id="printable_access_code"
				class="d-flex p-2"
				style="font-family: sans-serif"
			>
				<div class="d-flex">
					<div
						class="me-1"
						style="background-color: green; width: 20px; height: 100%"
					></div>
					<div style="background-color: green; width: 20px; height: 100%"></div>
				</div>
				<div class="p-3" style="width: 100%; height: 100%">
					<div class="text-center">
						<div>
							<img
								src="@/assets/images/inec_logo.jpeg"
								width="100"
								height="150"
							/>
						</div>
						<h2 style="font-weight: 700; color: green; text-align: center">
							INDEPENDENT NATIONAL ELECTORAL COMMISSION
						</h2>
						<h6 style="font-weight: 700">
							Plot 436 Zambezi Crescent, Maitama District, FCT, Abuja, NIGERIA
						</h6>
						<h2
							v-if="!access_code"
							class="mt-5 mb-2"
							style="font-weight: 700; color: black; text-align: center"
						>
							APPLICATION FOR REGISTRATION <br />
							AS A POLITICAL PARTY
						</h2>
					</div>
					<div class="mt-4">
						<table class="table">
							<thead>
								<tr>
									<th style="font-size: 15px; width: 30%">PROPOSED NAME:</th>
									<th style="font-size: 15px">{{ party.description }}</th>
								</tr>
								<tr>
									<th style="font-size: 15px; width: 30%">ACRONYM:</th>
									<th style="font-size: 15px">{{ party.abbreviation }}</th>
								</tr>
								<tr v-if="party.motto">
									<th style="font-size: 15px; width: 30%">SLOGAN:</th>
									<th style="font-size: 15px">{{ party.motto }}</th>
								</tr>
								<template v-if="!access_code">
									<tr>
										<th style="font-size: 15px; width: 30%">ADDRESS:</th>
										<th style="font-size: 15px">{{ party.head_office }}</th>
									</tr>
									<tr>
										<th style="font-size: 15px; width: 30%">
											PROTEM CHAIRMAN:
										</th>
										<th style="font-size: 15px">{{ party.protem_chairman }}</th>
									</tr>
									<tr>
										<th style="font-size: 15px; width: 30%">
											PROTEM SECRETARY:
										</th>
										<th style="font-size: 15px">
											{{ party.protem_secretary }}
										</th>
									</tr>
									<tr>
										<th style="font-size: 15px; width: 30%">OFFICIAL PHONE:</th>
										<th style="font-size: 15px">{{ party.official_phone }}</th>
									</tr>
									<tr>
										<th style="font-size: 15px; width: 30%">OFFICIAL EMAIL:</th>
										<th style="font-size: 15px">{{ party.official_email }}</th>
									</tr>
									<tr v-if="party.intent_letter">
										<th style="font-size: 15px; width: 30%">
											LETTER OF INTENT:
										</th>
										<th style="font-size: 15px">
											<a
												:href="party.intent_letter"
												target="_blank"
												class="btn btn-secondary"
												>View File</a
											>
										</th>
									</tr>
									<tr>
										<th style="font-size: 15px; width: 30%">
											APPLICATION STATUS
										</th>
										<th style="font-size: 15px">
											<span
												v-if="party.application_code"
												class="badge bg-success"
											>
												{{ party.application_code?.status }}
											</span>
											<span v-else class="badge bg-warning">
												{{ party.status }}
											</span>
										</th>
									</tr>
								</template>
								<tr v-if="party.logo">
									<th style="font-size: 15px; width: 30%">LOGO</th>
									<th style="font-size: 15px">
										<img
											:src="party.logo"
											alt="Party Logo"
											style="width: 70px; height: 80px"
										/>
									</th>
								</tr>
								<template v-if="access_code">
									<tr>
										<th style="font-size: 15px; width: 30%">
											APPLICATION LINK
										</th>
										<th
											style="
												font-size: 15px;
												text-transform: lowercase;
												color: red;
											"
										>
											https://pfras.inecnigeria.org/partyreg
										</th>
									</tr>
									<tr>
										<th style="font-size: 15px; width: 30%">ACCESS CODE</th>
										<th style="font-size: 15px; color: red">
											{{ access_code }}
										</th>
									</tr>
									<tr>
										<th colspan="2">
											<div style="font-size: 15px; margin-bottom: 1rem">
												Instructions:
											</div>

											<ul>
												<li>
													Visit
													<a
														style="text-transform: lowercase; font-size: 12px"
														href="https://pfras.inecnigeria.org/partyreg"
														>https://pfras.inecnigeria.org/partyreg</a
													>
												</li>
												<li style="font-size: 12px">
													Enter your Application Code exactly as it appears on
													the Access Code Slip issued to your association.
												</li>
												<li style="font-size: 12px">
													Click "Access" to start or continue your application.
												</li>
											</ul>
											<div style="font-size: 12px">
												Your code is unique to your association. <br />
												Keep it safe and do not share it with unauthorized
												persons.
												<p class="mt-2" style="font-size: 12px">
													<strong>Note:</strong> The Access Code is valid for
													<strong class="text-danger">30 days</strong>
													from the date it was first used on the portal.
												</p>
												<p style="font-size: 12px">
													Need Help? <br />
													For support or inquiries, please email
													<a
														style="text-transform: lowercase"
														href="mailto:ppa@inec.gov.ng"
														>ppa@inec.gov.ng</a
													>
												</p>
											</div>
										</th>
									</tr>
								</template>
							</thead>
						</table>
					</div>
				</div>
			</div>
			<div class="page-break"></div>
			<div
				v-if="party.executives && party.executives.length"
				class="p-3"
				style="width: 100%"
			>
				<div class="text-left">
					<h2
						class="mt-5 mb-2"
						style="font-weight: 700; color: black; text-align: left"
					>
						<span style="margin-right: 2rem">(A)</span>APPLICATION FOR
						REGISTRATION AS A POLITICAL PARTY
					</h2>
				</div>
				<div class="mt-5">
					<table class="table">
						<thead>
							<tr>
								<th style="font-size: 15px; width: 30%">
									FULL NAME OF ASSOCIATION:
								</th>
								<th style="font-size: 15px">{{ party.description }}</th>
							</tr>
							<tr>
								<th style="font-size: 15px; width: 30%">ACRONYM:</th>
								<th style="font-size: 15px">{{ party.abbreviation }}</th>
							</tr>
							<tr>
								<th style="font-size: 15px; width: 30%">SLOGAN:</th>
								<th style="font-size: 15px">{{ party.motto }}</th>
							</tr>
							<tr>
								<th style="font-size: 15px; width: 30%">PROTEM CHAIRMAN:</th>
								<th style="font-size: 15px">
									<div class="d-flex">
										<div v-if="party.protem_chairman_passport" class="me-2">
											<a :href="party.protem_chairman_passport" target="_blank">
												<img
													:src="party.protem_chairman_passport"
													alt="Chairman Passport"
													class="img-rounded"
													style="width: 70px; height: 70px; border-radius: 50%"
												/>
											</a>
										</div>
										<div class="mt-2">
											<a
												:href="party.protem_chairman_signature"
												target="_blank"
											>
												{{ party.protem_chairman }}
											</a>
											<br />
											<span
												v-if="party.protem_chairman_gender"
												class="badge bg-success text-small"
											>
												{{ party.protem_chairman_gender }}
											</span>
										</div>
									</div>
								</th>
							</tr>
							<tr>
								<th style="font-size: 15px; width: 30%">PROTEM SECRETARY:</th>
								<th style="font-size: 15px">
									<div class="d-flex">
										<div v-if="party.protem_secretary_passport" class="me-2">
											<a
												:href="party.protem_secretary_passport"
												target="_blank"
											>
												<img
													:src="party.protem_secretary_passport"
													alt="Chairman Passport"
													class="img-rounded"
													style="width: 70px; height: 70px; border-radius: 50%"
												/>
											</a>
										</div>
										<div class="mt-2">
											<a
												:href="party.protem_secretary_signature"
												target="_blank"
											>
												{{ party.protem_secretary }}
											</a>
											<br />
											<span
												v-if="party.protem_secretary_gender"
												class="badge bg-success text-small"
											>
												{{ party.protem_secretary_gender }}
											</span>
										</div>
									</div>
								</th>
							</tr>
							<tr>
								<th style="font-size: 15px; width: 30%">
									LOCATION OF ASSOCIATION HEAD OFFICE <br />
									AND MAILING ADDRESS IN FCT:
								</th>
								<th style="font-size: 15px">{{ party.head_office }}</th>
							</tr>
						</thead>
					</table>
				</div>

				<ApplicationApproval
					v-if="isCompleted"
					section="detail"
					:comments="party.approvals"
				/>
			</div>
			<div class="page-break"></div>
			<div
				v-if="party.executives && party.executives.length"
				class="p-3"
				style="width: 100%"
			>
				<div class="text-left">
					<h2
						class="mt-5 mb-2"
						style="font-weight: 700; color: black; text-align: left"
					>
						<span style="margin-right: 2rem">(B)</span> INTERIM NATIONAL
						EXECUTIVE COMMITТЕЕ
					</h2>
					<p style="font-size: 16px; text-align: left">
						The name, designation, state of origin, local government area,
						contact address, telephone number and signature of each member of
						the National Executive Committee (NEC) of the Association are as
						hereunder stated.
					</p>
				</div>
				<div class="mt-5">
					<table class="table table-bordered table-striped">
						<thead>
							<tr>
								<th
									colspan="12"
									class="text-center"
									style="background-color: black; color: white"
								>
									<h4 style="color: white">
										Interim National Executive Committee
									</h4>
								</th>
							</tr>
							<tr>
								<th>S/No</th>
								<th>Passport</th>
								<th>Name</th>
								<th>Gender</th>
								<th>State of Origin</th>
								<th>Local Govt. Area</th>
								<th>Contact Address</th>
								<th>Telephone No.</th>
								<th>Form of Identity</th>
								<th>Identity Number</th>
								<th>State of origin Certificate</th>
								<th class="no-print">Signature</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(executive, index) in party.executives"
								:key="executive.id"
								style="border-color: black"
							>
								<td>{{ index + 1 }}.</td>
								<td>
									<a :href="executive.passport" target="_blank">
										<img
											:src="executive.passport"
											alt="Passport"
											class="img-rounded"
											style="width: 60px; height: 40px"
										/>
									</a>
								</td>
								<td>{{ executive.full_name }}</td>
								<td>{{ executive.gender }}</td>
								<td>{{ executive.state.name }}</td>
								<td>{{ executive.lga.name }}</td>
								<td>{{ executive.contact_address }}</td>
								<td>{{ executive.phone }}</td>
								<td>
									<a :href="executive.id_card" target="_blank">
										{{ executive.proof.name }}
									</a>
								</td>
								<td>
									<a
										href="#!"
										@click="toggleMask(executive)"
										style="cursor: pointer"
									>
										{{ maskedId(executive) }}
									</a>
								</td>
								<td>
									<a :href="executive.state_of_origin" target="_blank">
										View
									</a>
								</td>
								<td class="no-print">
									<a :href="executive.signature_name" target="_blank"> View </a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<ApplicationApproval
					v-if="isCompleted"
					section="executive"
					:comments="party.approvals"
				/>
			</div>
			<div class="page-break"></div>
			<div
				v-if="party.trustees && party.trustees.length"
				class="p-3"
				style="width: 100%; display: none"
			>
				<div class="text-left">
					<h2
						class="mt-5 mb-2"
						style="font-weight: 700; color: black; text-align: left"
					>
						<span style="margin-right: 2rem">(C)</span> INTERIM MEMBERS OF BOARD
						OF TRUSTEES (BOT)/OTHER PRINCIPAL ORGANS(S) - INFORMATION ONLY
					</h2>
					<p style="font-size: 16px; text-align: left">
						The name, designation, state of origin, local government area,
						contact address, telephone number and signature of each member of
						the Board of Trustees (BOT) / other principal organ(s) of the
						Association are as hereunder stated.
					</p>
				</div>
				<div class="mt-5">
					<table class="table table-bordered table-striped">
						<thead>
							<tr>
								<th
									colspan="10"
									class="text-center"
									style="background-color: black; color: white"
								>
									<h4 style="color: white">
										Interim Members of Board of Trustees / Other Principal
										Organ(s)
									</h4>
								</th>
							</tr>
							<tr>
								<th>S/No</th>
								<th>Passport</th>
								<th>Name</th>
								<th>Gender</th>
								<th>State of Origin</th>
								<th>Local Govt. Area</th>
								<th>Contact Address</th>
								<th>Telephone No.</th>
								<th>Form of Identity</th>
								<th class="no-print">Signature</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(executive, index) in party.trustees"
								:key="executive.id"
								style="border-color: black"
							>
								<td>{{ index + 1 }}.</td>
								<td>
									<a :href="executive.passport" target="_blank">
										<img
											:src="executive.passport"
											alt="Passport"
											class="img-rounded"
											style="width: 60px; height: 40px"
										/>
									</a>
								</td>
								<td>{{ executive.full_name }}</td>
								<td>{{ executive.gender }}</td>
								<td>{{ executive.state.name }}</td>
								<td>{{ executive.lga.name }}</td>
								<td>{{ executive.contact_address }}</td>
								<td>{{ executive.phone }}</td>
								<td>
									<a :href="executive.id_card" target="_blank">
										{{ executive.proof.name }}
									</a>
								</td>
								<td class="no-print">
									<a :href="executive.signature_name" target="_blank"> View </a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- <ApplicationApproval
					v-if="isCompleted"
					section="trustee"
					:comments="party.approvals"
				/> -->
			</div>
			<!-- <div class="page-break"></div> -->
			<div
				v-if="party.executives && party.executives.length"
				class="p-3"
				style="width: 100%"
			>
				<div class="text-left">
					<h2
						class="mt-5 mb-2"
						style="font-weight: 700; color: black; text-align: left"
					>
						<span style="margin-right: 2rem">(C)</span> FULL-TIME ADMINISTRATIVE
						PERSONNEL AT NATIONAL LEVEL
					</h2>
					<p style="font-size: 16px; text-align: left">
						The name, designation, state of origin, local government area,
						contact address, telephone number and signature of administrative
						personnel in the employment of the Association are as hereunder
						stated.
					</p>
				</div>
				<div class="mt-5">
					<table class="table table-bordered table-striped">
						<thead>
							<tr>
								<th
									colspan="11"
									class="text-center"
									style="background-color: black; color: white"
								>
									<h4 style="color: white">
										Administrative Personnel At National Level
									</h4>
								</th>
							</tr>
							<tr>
								<th>S/No</th>
								<th>Passport</th>
								<th>Name</th>
								<th>Gender</th>
								<th>Role</th>
								<th>State of Origin</th>
								<th>Local Govt. Area</th>
								<th>Contact Address</th>
								<th>Telephone No.</th>
								<th>Form of Identity</th>
								<th class="no-print">Signature</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(executive, index) in party.personnel"
								:key="executive.id"
								style="border-color: black"
							>
								<td>{{ index + 1 }}.</td>
								<td>
									<a :href="executive.passport" target="_blank">
										<img
											:src="executive.passport"
											alt="Passport"
											class="img-rounded"
											style="width: 60px; height: 40px"
										/>
									</a>
								</td>
								<td>{{ executive.full_name }}</td>
								<td>{{ executive.gender }}</td>
								<td>{{ executive.role }}</td>
								<td>{{ executive.state.name }}</td>
								<td>{{ executive.lga.name }}</td>
								<td>{{ executive.contact_address }}</td>
								<td>{{ executive.phone }}</td>
								<td>
									<a :href="executive.id_card" target="_blank">
										{{ executive.proof.name }}
									</a>
								</td>
								<td class="no-print">
									<a :href="executive.signature_name" target="_blank"> View </a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<ApplicationApproval
					v-if="isCompleted"
					section="personnel"
					:comments="party.approvals"
				/>
			</div>
			<div class="page-break"></div>
			<div
				class="p-3"
				v-if="party.executives && party.executives.length"
				style="width: 100%"
			>
				<div class="text-left">
					<h2
						class="mt-5 mb-2"
						style="font-weight: 700; color: black; text-align: left"
					>
						<span style="margin-right: 2rem">(D)</span> BANK DETAILS OF THE
						ASSOCIATION
					</h2>
					<p style="font-size: 16px; text-align: left">
						The name of the bank, account name and account number of the
						association are as hereunder stated.
					</p>
				</div>
				<div class="mt-5">
					<table class="table table-bordered table-striped">
						<thead>
							<tr>
								<th
									colspan="10"
									class="text-center"
									style="background-color: black; color: white"
								>
									<h4 style="color: white">Bank Details</h4>
								</th>
							</tr>
							<tr>
								<th>S/No</th>
								<th>Bank Name</th>
								<th>Account Name</th>
								<th>Account Number</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(bank, index) in party.bank_details"
								:key="bank.id"
								style="border-color: black"
							>
								<td>{{ index + 1 }}.</td>
								<td>{{ bank.bank_name }}</td>
								<td>{{ bank.account_name }}</td>
								<td>{{ bank.account_number }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="page-break"></div>
			<div
				v-if="party.attachments && party.attachments.length"
				class="p-3"
				style="width: 100%"
			>
				<div class="text-left">
					<h2
						class="mt-5 mb-2"
						style="font-weight: 700; color: black; text-align: left"
					>
						<span style="margin-right: 2rem">(E)</span>ATTACHED HERETO ARE THE
						FOLLOWING DOCUMENTS
					</h2>
				</div>
				<div class="mt-5">
					<table class="table">
						<thead>
							<tr>
								<th style="font-size: 15px">Association's Constitution:</th>
								<th>
									<a
										v-if="party.attachments[0].association_constitution"
										:href="party.attachments[0].association_constitution"
										target="_blank"
										class="btn btn-outline-secondary"
										>View File</a
									>
									<!-- <span v-else class="text-danger">Not Uploaded</span> -->
								</th>
							</tr>
							<tr>
								<th style="font-size: 15px">
									Association's Manifesto showing its aims and objectives:
								</th>
								<th>
									<a
										v-if="party.attachments[0].association_manifesto"
										:href="party.attachments[0].association_manifesto"
										target="_blank"
										class="btn btn-outline-secondary"
										>View File</a
									>
									<!-- <span v-else class="text-danger">Not Uploaded</span> -->
								</th>
							</tr>
							<tr>
								<th style="font-size: 15px">
									Evidence of payment of Administrative fee:
								</th>
								<th>
									<a
										v-if="party.attachments[0].administrative_fee"
										:href="party.attachments[0].administrative_fee"
										target="_blank"
										class="btn btn-outline-secondary"
										>View File</a
									>
									<!-- <span v-else class="text-danger">Not Uploaded</span> -->
								</th>
							</tr>
							<tr>
								<th style="font-size: 15px">
									Evidence of INEC Official receipt:
								</th>
								<th>
									<a
										v-if="party.attachments[0].administrative_fee_receipt"
										:href="party.attachments[0].administrative_fee_receipt"
										target="_blank"
										class="btn btn-outline-secondary"
										>View File</a
									>
									<!-- <span v-else class="text-danger">Not Uploaded</span> -->
								</th>
							</tr>
							<tr>
								<th style="font-size: 15px">
									Address of office in the FCT and evidence of ownership <br />
									or tenancy, payment of tenancy on such offices <br />
									by the Association:
								</th>
								<th>
									<a
										v-if="party.attachments[0].evidence_of_tenancy"
										:href="party.attachments[0].evidence_of_tenancy"
										target="_blank"
										class="btn btn-outline-secondary"
										>View File</a
									>
									<!-- <span v-else class="text-danger">Not Uploaded</span> -->
								</th>
							</tr>
							<tr>
								<th style="font-size: 15px">Registration of Membership:</th>
								<th>
									<a
										v-if="party.attachments[0].membership_registration"
										:href="party.attachments[0].membership_registration"
										target="_blank"
										class="btn btn-outline-secondary"
										>View File</a
									>
									<!-- <span v-else class="text-danger">Not Uploaded</span> -->
								</th>
							</tr>
							<tr>
								<th style="font-size: 15px">Logo of the Association:</th>
								<th>
									<a
										v-if="party.logo"
										:href="party.logo"
										target="_blank"
										class="btn btn-outline-secondary"
										>View File</a
									>
									<!-- <span v-else class="text-danger">Not Uploaded</span> -->
								</th>
							</tr>
							<tr>
								<th style="font-size: 15px">
									Sworn affidavit of Chairman or Secretary:
								</th>
								<th>
									<a
										v-if="party.attachments[0].sworn_affidavit"
										:href="party.attachments[0].sworn_affidavit"
										target="_blank"
										class="btn btn-outline-secondary"
										>View File</a
									>
									<!-- <span v-else class="text-danger">Not Uploaded</span> -->
								</th>
							</tr>
							<tr>
								<th style="font-size: 15px">Association Physical Office:</th>
								<th>
									<a
										v-if="party.attachments[0].physical_office"
										:href="party.attachments[0].physical_office"
										target="_blank"
										class="btn btn-outline-secondary"
										>View File</a
									>
									<!-- <span v-else class="text-danger">Not Uploaded</span> -->
								</th>
							</tr>
							<tr v-if="registration_approvals">
								<th style="font-size: 15px">
									Registration Certificate (From INEC):
								</th>
								<th>
									<a
										v-if="registration_doc && registration_doc.approval_doc"
										:href="registration_doc.approval_doc"
										target="_blank"
										class="btn btn-outline-secondary"
										>View File</a
									>
									<!-- <span v-else class="text-danger">Not Uploaded</span> -->
								</th>
							</tr>
						</thead>
					</table>
				</div>
				<ApplicationApproval
					v-if="isCompleted"
					section="attachment"
					:comments="party.approvals"
				/>
			</div>
			<div class="page-break"></div>
			<div v-if="provisional_approvals" class="p-3">
				<div
					v-for="(comment, index) in provisional_approvals"
					class="card mb-3 border-0 bg-light"
					:key="'comment_' + index"
				>
					<div class="card-body p-3">
						<div class="d-flex">
							<img
								src="@/assets/images/logo.png"
								alt="User"
								class="rounded-circle me-3"
								width="60"
								height="60"
							/>
							<div class="flex-grow-1">
								<div class="d-flex justify-content-between mb-1">
									<div>
										<strong>{{ comment.creator.name }}</strong>
										<small class="text-muted ms-2"
											>({{ comment.creator.designation }})</small
										>
									</div>
									<div>
										<small class="text-muted"
											><i class="fas fa-clock text-warning"></i>
											{{ comment.created_at }}</small
										>
										<br />
										<span
											v-if="comment.status == 'Approved'"
											class="badge bg-success"
											>Application Recommended</span
										>
										<span v-else class="badge bg-danger"
											>Application {{ comment.status }}</span
										>
									</div>
								</div>
								<p
									class="mb-2"
									v-html="
										comment.comment ?? 'Application verified and approved'
									"
								></p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="registration_approvals" class="p-3">
				<div
					v-for="(comment, index) in registration_approvals"
					class="card mb-3 border-0 bg-light"
					:key="'comment_' + index"
				>
					<div class="card-body p-3">
						<div class="d-flex">
							<img
								src="@/assets/images/logo.png"
								alt="User"
								class="rounded-circle me-3"
								width="60"
								height="60"
							/>
							<div class="flex-grow-1">
								<div class="d-flex justify-content-between mb-1">
									<div>
										<strong>{{ comment.creator.name }}</strong>
										<small class="text-muted ms-2"
											>({{ comment.creator.designation }})</small
										>
									</div>
									<div>
										<small class="text-muted"
											><i class="fas fa-clock text-warning"></i>
											{{ comment.created_at }}</small
										>
										<br />
										<span
											v-if="comment.status == 'Approved'"
											class="badge bg-success"
											>Party Registered</span
										>
										<span v-else class="badge bg-danger"
											>Application Rejected</span
										>
									</div>
								</div>
								<p
									class="mb-2"
									v-html="
										comment.comment ?? 'Application verified and approved'
									"
								></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-3 pb-3 p-2 text-center">
			<button class="btn btn-warning me-1" @click="$router.go(-1)">
				<i class="fas fa-arrow-left me-2"></i>Go Back
			</button>

			<!-- Access Code Button -->
			<button
				v-if="canShowAccessCodeButton"
				class="btn btn-secondary me-1"
				@click.prevent="downloadAccessCode"
				:disabled="isLoading"
			>
				<span v-if="isLoading">Please wait...</span>
				<span v-else
					><i class="fas fa-download me-2"></i> Download Access Code</span
				>
			</button>

			<!-- Application Form -->
			<button
				v-if="canShowApplicationFormButton || canShowPartyRegistration"
				@click.prevent="downloadPDF('application')"
				class="btn btn-secondary me-1"
				:disabled="isLoading"
			>
				<span v-if="isLoading">Please wait...</span>
				<span v-else>
					<i class="fas fa-download me-2"></i> Download Application Form</span
				>
			</button>

			<!-- Provisional Approval -->
			<template v-if="canShowProvisionalApproval">
				<ProvisionalApprovalModal v-show="showRecommendModal" />
				<button class="btn btn-primary" @click="showModal('recommend')">
					<i class="fas fa-cog me-2"></i>Recommend
				</button>
			</template>

			<!-- Party Registration -->
			<template v-if="canShowPartyRegistration">
				<PartyRegistrationModal v-show="showRegisterModal" />
				<PartyRejectionModal v-show="showRejectionModal" />
				<button class="btn btn-info me-2" @click="showModal('register')">
					<i class="fas fa-save me-2"></i>Register Association as a Party
				</button>
				<button class="btn btn-danger" @click.prevent="showModal('reject')">
					<i class="fas fa-cog me-2"></i>Reject Application
				</button>
			</template>

			<!-- Generate Access Code -->
			<button
				v-if="canShowGenerateCodeButton"
				class="btn btn-info me-1"
				@click.prevent="generateCode"
			>
				<span v-if="isLoading">Please wait...</span>
				<span v-else>Generate Access Code</span>
			</button>

			<!-- Download Intent Form -->
			<button
				v-if="canDownloadIntentForm"
				@click.prevent="downloadIntentPDF()"
				class="btn btn-secondary"
			>
				Download Intent Form
			</button>
		</div>
	</div>
</template>
<script>
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
// import { Datepicker } from "vanillajs-datepicker";
// import "vanillajs-datepicker/css/datepicker-bs5.css";
import { EventBus } from "@/utils/event_bus.js";
import html2pdf from "html2pdf.js";
import { PDFDocument } from "pdf-lib";
import ApplicationApproval from "./Partials/ApplicationApproval.vue";
import ProvisionalApprovalModal from "./Partials/ProvisionalApprovalModal.vue";
import PartyRegistrationModal from "./Partials/PartyRegistrationModal.vue";
import PartyRejectionModal from "./Partials/PartyRejectionModal.vue";
import { userHasPermission } from "@/utils/permissions";

export default {
	components: {
		ApplicationApproval,
		PartyRegistrationModal,
		PartyRejectionModal,
		ProvisionalApprovalModal,
	},
	computed: {
		...mapGetters({
			party: "parties/party",
		}),

		user_can_approve_section() {
			return userHasPermission("party-registration-create");
		},
		user_can_generate_code() {
			return userHasPermission("party-registration-access");
		},
		user_can_approve_application() {
			return userHasPermission("party-registration-update");
		},
		user_can_register_application() {
			return userHasPermission("party-registration-delete");
		},
		hasApplicationCode() {
			return !!this.party?.application_code;
		},

		isRejected() {
			return this.party?.status === "Rejected";
		},

		canShowAccessCodeButton() {
			const codeStatus = this.party?.application_code?.status;

			return (
				this.hasApplicationCode &&
				this.user_can_generate_code &&
				this.party.status != "Active" &&
				["Code Generated", "In-Progress"].includes(codeStatus)
			);
		},

		canShowGenerateCodeButton() {
			return (
				!this.hasApplicationCode &&
				this.user_can_generate_code &&
				this.party.status != "Active" &&
				!this.isRejected
			);
		},

		isCompleted() {
			if (!this.party || !this.party.application_code) {
				return false;
			}

			// Then safely check the status
			const status = this.party.application_code.status;
			return status === "Completed" || status === "Accepted";
		},

		canShowApplicationFormButton() {
			return this.isCompleted && !this.isRejected;
		},

		canShowProvisionalApproval() {
			return (
				this.canShowApplicationFormButton &&
				this.isAdminApproved &&
				this.user_can_approve_application &&
				!this.isProvisionalApproved
			);
		},

		canShowPartyRegistration() {
			return (
				this.isProvisionalApproved &&
				this.user_can_register_application &&
				!this.isRegistrationApproved &&
				!this.isRejected
			);
		},

		canDownloadIntentForm() {
			return (
				!this.hasApplicationCode &&
				!this.isRejected &&
				this.party.status != "Active"
			);
		},
		provisional_approvals() {
			if (this.party && this.party.approvals) {
				return this.party.approvals.filter(
					(approval) => approval.section == "provisional_approval"
				);
			}

			return [];
		},
		registration_doc() {
			if (this.party && this.party.approvals) {
				return this.party.approvals.find(
					(approval) => approval.section == "registration_approval"
				);
			}

			return null;
		},
		registration_approvals() {
			if (this.party && this.party.approvals) {
				return this.party.approvals.filter(
					(approval) => approval.section == "registration_approval"
				);
			}

			return [];
		},
		isAdminApproved() {
			if (this.party && this.party.approvals) {
				let approvals = this.party.approvals.filter(
					(approval) =>
						approval.status == "Accepted" || approval.status == "Approved"
				);

				if (approvals.length >= 2) {
					return true;
				}
			}

			return false;
		},

		isProvisionalApproved() {
			if (this.party && this.party.approvals) {
				let approvals = this.party.approvals.filter(
					(approval) => approval.section == "provisional_approval"
				);

				if (approvals.length > 0) {
					return true;
				}
			}

			return false;
		},

		isRegistrationApproved() {
			if (this.party && this.party.approvals) {
				let approvals = this.party.approvals.filter(
					(approval) => approval.section == "registration_approval"
				);

				if (approvals.length > 0) {
					return true;
				}
			}

			return false;
		},

		maskedId() {
			return (executive) => {
				if (!executive.id_number) {
					return "";
				}

				return executive.showFullId
					? executive.id_number
					: "••••••••" + executive.id_number.slice(-4);
			};
		},

		checkExecutives() {
			if (this.party && this.party.executives.length < 25) {
				return Swal.fire({
					icon: "error",
					title: "Insufficient Executives",
					text: "This association does not meet the minimum requirement of 25 Interim Executive Committee.",
				});
			}

			return null;
		},
	},

	// watch: {
	// 	party: {
	// 		handler() {
	// 			this.checkExecutives;
	// 		},
	// 		immediate: true,
	// 		deep: true,
	// 	},
	// },

	data() {
		return {
			access_code: null,
			isLoading: false,
			showRegisterModal: false,
			showRejectionModal: false,
			showRecommendModal: false,
		};
	},

	methods: {
		getPartyDetails() {
			this.$store.dispatch("parties/getPartyDetails", {
				partyID: this.$route.params.id,
			});
		},

		downloadPDF(type) {
			this.isLoading = true;
			// Hide elements
			document
				.querySelectorAll(".no-print")
				.forEach((el) => (el.style.display = "none"));
			const element = document.getElementById("printable");
			const file_name =
				type == "intent"
					? `${this.party.abbreviation} INTENT FORM`
					: `${this.party.abbreviation} APPLICATION FORM`;

			let externalPdfUrls = [];
			const attachment = this.party.attachments[0];

			if (this.party.logo) {
				externalPdfUrls.push(this.party.logo);
			}

			if (this.party.intent_letter) {
				externalPdfUrls.push(this.party.intent_letter);
			}

			const attachmentKeys = [
				"sworn_affidavit",
				"membership_registration",
				"evidence_of_tenancy",
				"administrative_fee_receipt",
				"administrative_fee",
				"association_manifesto",
				"association_constitution",
				"physical_office",
			];

			attachmentKeys.forEach((key) => {
				if (attachment[key]) {
					externalPdfUrls.push(attachment[key]);
				}
			});

			html2pdf()
				.set({
					margin: [10, 10, 10, 10],
					filename: type + "_combined.pdf",
					image: { type: "jpeg", quality: 0.98 },
					html2canvas: { scale: 2, useCORS: true },
					jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
					pagebreak: { mode: ["css", "legacy"] },
				})
				.from(element)
				.outputPdf("blob")
				.then(async (pdfBlob) => {
					await this.mergeAndDownloadPDF(file_name, pdfBlob, externalPdfUrls);
					this.isLoading = false;
					document
						.querySelectorAll(".no-print")
						.forEach((el) => (el.style.display = ""));
				})
				.catch((error) => {
					console.log(error);

					this.isLoading = false;
					document
						.querySelectorAll(".no-print")
						.forEach((el) => (el.style.display = ""));
					Swal.fire({
						icon: "error",
						text: "Failed to download pdf, please try again",
					});
				});
		},

		async mergeAndDownloadPDF(file_name, mainPdfBlob, urls = []) {
			const mainPdf = await PDFDocument.load(await mainPdfBlob.arrayBuffer());

			for (const url of urls) {
				try {
					const response = await fetch(url);
					if (!response.ok) {
						throw new Error(`Failed to fetch ${url}`);
					}

					const contentType = response.headers.get("Content-Type");
					const data = await response.arrayBuffer();

					// Handle PDF files
					if (
						contentType.includes("application/pdf") ||
						url.toLowerCase().endsWith(".pdf")
					) {
						const externalPdf = await PDFDocument.load(data);
						const copiedPages = await mainPdf.copyPages(
							externalPdf,
							externalPdf.getPageIndices()
						);
						copiedPages.forEach((page) => mainPdf.addPage(page));
					}

					// Handle image files
					else if (
						contentType.startsWith("image/") ||
						/\.(jpe?g|png|gif|bmp|webp)$/i.test(url)
					) {
						const image = contentType.includes("png")
							? await mainPdf.embedPng(data)
							: await mainPdf.embedJpg(data); // assume JPG fallback

						const dims = image.scale(0.7); // scale down a bit
						const page = mainPdf.addPage([dims.width + 40, dims.height + 40]);
						page.drawImage(image, {
							x: 20,
							y: 20,
							width: dims.width,
							height: dims.height,
						});
					}

					// Unsupported types
					else {
						console.warn(`Unsupported file type: ${url}`);
						Swal.fire({
							icon: "warning",
							title: "Skipped File",
							text: `Unsupported file type for:\n${url}`,
						});
					}
				} catch (err) {
					console.error(`Error processing: ${url}`, err);
					Swal.fire({
						icon: "error",
						title: "Fetch Failed",
						text: `Could not load or merge:\n${url}`,
					});
					return;
				}
			}

			const mergedPdfBytes = await mainPdf.save();
			const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });

			const link = document.createElement("a");
			link.href = URL.createObjectURL(blob);
			link.download = file_name.endsWith(".pdf")
				? file_name
				: file_name + ".pdf";
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},

		downloadIntentPDF() {
			this.isLoading = true;
			const element = document.getElementById("printable_access_code");

			// Hide elements
			document
				.querySelectorAll(".no-print")
				.forEach((el) => (el.style.display = "none"));

			html2pdf()
				.set({
					margin: [10, 10, 10, 10], // [top, left, bottom, right]
					filename: `${this.party.abbreviation} INTENT FORM`,
					image: { type: "jpeg", quality: 0.98 },
					html2canvas: {
						scale: 2, // Higher scale = better quality
						useCORS: true, // Allow external images
					},
					jsPDF: {
						unit: "mm",
						format: "a4",
						orientation: "portrait",
					},
					pagebreak: {
						mode: ["css", "legacy"], // Breaks using CSS and default logic
					},
				})
				.from(element)
				.toContainer()
				.toCanvas()
				.toImg()
				.toPdf()
				.save()
				.then(() => {
					this.isLoading = false;
					document
						.querySelectorAll(".no-print")
						.forEach((el) => (el.style.display = ""));
				})
				.catch(() => {
					this.isLoading = false;
					document
						.querySelectorAll(".no-print")
						.forEach((el) => (el.style.display = ""));
					Swal.fire({
						icon: "error",
						text: "Failed to download pdf, please try again",
					});
				});
		},

		downloadAccessCode() {
			this.isLoading = true;
			this.$store
				.dispatch("parties/getAccessCode", {
					partyID: this.$route.params.id,
				})
				.then((resp) => {
					if (resp.status_code === 200 && resp.data.access_code) {
						this.access_code = resp.data.access_code;
						const element = document.getElementById("printable_access_code");
						html2pdf()
							.set({
								margin: [10, 10, 10, 10], // [top, left, bottom, right]
								filename: `${this.party.abbreviation} ACCESS CODE.pdf`,
								image: { type: "jpeg", quality: 0.98 },
								html2canvas: {
									scale: 2, // Higher scale = better quality
									useCORS: true, // Allow external images
								},
								jsPDF: {
									unit: "mm",
									format: "a4",
									orientation: "portrait",
								},
								pagebreak: {
									mode: ["css", "legacy"], // Breaks using CSS and default logic
								},
							})
							.from(element)
							.toContainer()
							.toCanvas()
							.toImg()
							.toPdf()
							.save()
							.then(() => {
								this.access_code = null;
								this.isLoading = false;
							});
					} else {
						this.isLoading = false;
						Swal.fire({
							icon: "error",
							title: "Failed to find access code",
						});
					}
				});
		},

		generateCode() {
			Swal.fire({
				title: "Generate Code",
				icon: "info",
				showCancelButton: true,
				confirmButtonColor: "#29623c",
				cancelButtonColor: "#6c757d",
				confirmButtonText: "Yes, proceed",
				cancelButtonText: "Cancel",
				focusConfirm: false,
			}).then((result) => {
				if (result.isConfirmed) {
					this.isLoading = true;
					let payload = {
						party_id: this.$route.params.id,
						// deadline: result.value.deadline,
					};

					this.$store
						.dispatch("parties/generateApplicationCode", payload)
						.then((resp) => {
							if (resp.status_code === 201) {
								Swal.fire({
									icon: "success",
									title: "Success",
									text: resp.status_message, // + ": " + resp.data.code,
								});
								this.isLoading = false;
							} else {
								Swal.fire({
									icon: "error",
									title: "Error",
									text: resp.response.data.errors.message,
								});
								this.isLoading = false;
							}
						});
				}
			});
		},

		toggleMask(executive) {
			if (!Object.prototype.hasOwnProperty.call(executive, "showFullId")) {
				this.$set(executive, "showFullId", false);
			}
			executive.showFullId = !executive.showFullId;
		},

		showModal(type) {
			if (type == "reject") {
				this.showRejectionModal = true;
				this.showRegisterModal = false;
				this.showRecommendModal = false;
			}
			if (type == "register") {
				this.showRejectionModal = false;
				this.showRegisterModal = true;
				this.showRecommendModal = false;
			}
			if (type == "recommend") {
				this.showRejectionModal = false;
				this.showRegisterModal = false;
				this.showRecommendModal = true;
			}

			EventBus.$emit("toggle-modal", "show");
		},
	},

	mounted() {
		this.getPartyDetails();
	},
};
</script>
<style scoped>
.bg-info {
	background-color: #29623c !important;
}
.datepicker-dropdown {
	position: unset !important;
}
.table-bordered {
	border: 2px solid black !important;
}
.table-bordered td,
.table-bordered th {
	border: 1px solid black !important;
}
th,
td {
	text-wrap: auto !important;
}
@media print {
	.no-print {
		display: none !important;
	}
}
</style>
